// extracted by mini-css-extract-plugin
module.exports = {"zeroPadding":"cart-sidebar_zeroPadding__IGN_w","tabs":"cart-sidebar_tabs__q_oJX","tab":"cart-sidebar_tab__1OLMr","active":"cart-sidebar_active__4jC3u"};